import React from "react";
import PropTypes from "prop-types";
import { withApollo } from "react-apollo";
import StreamEvents from "../services/StreamEvents";
import { NOTIFICATIONS_QUERY } from "../queries";
import activityUrl from "../services/activityUrl";
import { NotificationsContext } from "../NotificationsContext";
import MarkAllRead from "./MarkAllRead";
import NotificationsListData from "./NotificationsListData";
import UnseenCount from "./UnseenCount";
import SvgBell from "./SvgBell";
import { Utils, Settings } from "@services";

class Notifications extends React.Component {
  static propTypes = {
    markAllSeen: PropTypes.func.isRequired,
    refreshUnseenCount: PropTypes.func.isRequired,
  };

  state = {
    open: false,
  };

  componentDidMount() {
    this.listen();
  }

  toggleOpen = (e) => {
    e.preventDefault();

    if (this.state.open) {
      this.hide();
    } else {
      this.open();
    }
  };

  open = () => {
    document.addEventListener("click", this.handleHide);
    this.setState({ open: true });
    this.props.markAllSeen();
  };

  hide = () => {
    document.removeEventListener("click", this.handleHide);
    this.setState({ open: false });
  };

  handleHide = () => {
    this.hide();
  };

  listen = () => {
    StreamEvents.listen(Settings.currentUser.id);

    // remove existing listener
    if (window.notificationListener) {
      window.removeEventListener("stream-notification", window.notificationListener);
    }

    // assign new listener function
    window.notificationListener = (e) => {
      this.props.refreshUnseenCount();
      this.loadNotification(String(e.detail.id));
    };

    // add listener
    window.addEventListener("stream-notification", window.notificationListener);
  };

  loadNotification = async (activityId) => {
    const { client } = this.props;

    const { data } = await client.query({
      query: NOTIFICATIONS_QUERY,
      variables: { first: 25 },
    });

    const notification = data.Viewer.notifications.find((n) =>
      n.activities.some((activity) => activity.id === activityId)
    );

    if (notification) {
      this.toast(notification);
    }
  };

  toast = (notification) => {
    const url = Utils.addUTM(activityUrl(notification), "feed", "toast", "");
    const toastContent = `
      <span>${notification.description}</span>
      <a class="btn-flat toast-action" href="${url}">View</a>
    `;

    Materialize.toast(toastContent, 5000);
  };

  render() {
    return (
      <div className="notifications-container">
        <div className="notifications-header">
          <a
            className="notifications-header__link navbar--team"
            title="My notifications"
            onClick={(e) => this.toggleOpen(e)}
          >
            {/* <i className="material-icons">notifications</i> */}
            <SvgBell />
            <UnseenCount />
          </a>
        </div>

        {this.state.open ? (
          <div className="notifications-content">
            <div className="notifications-content__header">
              <span className="notifications-content__label block-text">Notifications</span>
              <MarkAllRead />
            </div>
            <NotificationsListData />
          </div>
        ) : null}
      </div>
    );
  }
}

export default withApollo((props) => (
  <NotificationsContext.Consumer>
    {({ markAllSeen, refreshUnseenCount }) => (
      <Notifications {...props} markAllSeen={markAllSeen} refreshUnseenCount={refreshUnseenCount} />
    )}
  </NotificationsContext.Consumer>
));
